'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var ArrowDown = function ArrowDown(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 360 227.3' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { fill: 'currentColor', d: 'M358 44.7L313.7 1.6 183.4 135.8 45.3 1.6 2.3 46l178.4 171.4 4.9 4.8z' })
    )
  );
};
/*eslint-enable */

exports.default = ArrowDown;
//# sourceMappingURL=ArrowDown.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/ArrowDown.js